import React, { Component, Fragment } from 'react';
import { isEmpty, size } from "lodash"

import { 
    Grid ,
    Button ,
} from '@mui/material';

import DatePicker from '../../common/DatePicker';
import ReceivePayment from './ReceivePayment';
import InputText, { InputSelectNative, TextArea } from '../../common/Form';
import Dialog from '../../common/Dialog';

class PaymentForm extends Component {
    state = { 
        payment_total_amount : this.props.payment ? this.props.payment.payment_total_amount : "",
        payment_desc : this.props.payment ? this.props.payment.payment_desc : "",
        payment_remarks: this.props.payment ? this.props.payment.payment_remarks : "",
        payment_bank: this.props.payment ? this.props.payment.payment_bank : "",
        payment_mode: this.props.payment ? this.props.payment.payment_mode : "",
        payment_ref: this.props.payment ? this.props.payment.payment_ref : "",
        payment_date: this.props.payment ? this.props.payment.payment_date : new Date(),
        payments: [
            {
                payment_spending_id: "",
                payment_amount: "",
            }
        ],
        errors:{
            payment_total_amount: "",
            payment_bank: "",
            payment_mode: "",
            payment_date: "",
            payments: [
                {
                    payment_spending_id: "",
                    payment_amount: "",
                }
            ],
        },
        filteredSpendings: {},
        nbPayment: 1,
        open: false,
    }
    componentDidMount() {
        const { SPENDINGS, spendings, update } = this.props;
        
        
        if ( !isEmpty(SPENDINGS) && !isEmpty(spendings) && !update ){
            let payments = []
            let errors = []
            let filteredSpendings = {}

            let filteredArray = Object.values(SPENDINGS).filter( item => !item.spending_fully_paid )
            filteredArray.map( item => {
                filteredSpendings[item.spending_id] = item
            })
            spendings.map( spendID => {
                payments.push({
                    payment_spending_id: spendID,
                    payment_amount: SPENDINGS[spendID] ? SPENDINGS[spendID].spending_rest_to_pay : "",
                })
                errors.push({
                    payment_spending_id: "",
                    payment_amount: "",
                })
            })

            this.setState({
                payments,
                errors:{
                    ...this.state.errors,
                    payments:errors,
                },
                nbPayment : size(spendings),
                filteredSpendings,
            })
        }
    }
    // FORM
    handleChange = (e) => {

        const name = e.target.name
        const value = e.target.value
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "payment_total_amount"]

        if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: value
            })
        }
    }

    handleChangePayments = (name, value, index) => {
        console.log('=========== handleChangePayments ===============');
        console.log({name, value, index});
        
        let cpPayments = [].concat(this.state.payments)   
        cpPayments[index][name] = value 
        console.table(cpPayments);

        this.setState({
            ...this.state,
            payments: cpPayments
        })
    }
    handleChangeDate = (date) => {        
        this.setState({
            payment_date: date
        })
    }
    handleAddForm = () => {
        this.setState({
            nbPayment: this.state.nbPayment + 1,
            payments: [
                ...this.state.payments,
                {
                    payment_spending_id: "",
                    payment_amount: "",
                }
            ],
            errors: {
                ...this.state.errors,
                payments:[
                    ...this.state.errors.payments,{
                        payment_spending_id: "",
                        payment_amount: "",
                    } 
                ]
            },
        })
    }
    createAddForm = () => {
        const { nbPayment, payments, filteredSpendings } = this.state
        
        let selected = payments.map( item => item.payment_spending_id)
        let tab = []
        for(let i = 0; i < nbPayment; i++){
            tab.push(
                <ReceivePayment
                    {...this.state.payments[i]}
                    SPENDINGS={filteredSpendings}
                    selected={selected}
                    spending={filteredSpendings[payments[i].payment_spending_id]}
                    errors={this.state.errors.payments[i]} 
                    handleChange={this.handleChangePayments} 
                    index={i} 
                />
            )
        }
        return tab
    }

    validatePayments = () => {
        const { SPENDINGS } = this.props;
        let payments = [].concat(this.state.payments)
        let required = [
            "payment_amount",
            "payment_spending_id",
        ]
        let errors = [].concat(this.state.errors.payments)
        let noError = true

        let total = 0
        payments.forEach( (pay, index) => {
            required.forEach(field => {
                if( isEmpty(pay[field]) && !pay[field] ) { 
                    console.log(`${field} is empty`)
                    noError = false
                    errors[index][field] = "Veuillez remplir ce Champ" 
                } else {
                    errors[field] = "" 
                }
            })

            let spending = SPENDINGS[pay.payment_spending_id]
            if (spending) {
                if (spending.spending_rest_to_pay < pay.payment_amount){
                    errors[index].payment_amount = `Reste à payer : ${spending.spending_rest_to_pay}`
                    noError = false
                } else {
                    errors[index].payment_amount = ""
                }

            }
            total += pay.payment_amount
        })
        return {
            noError, errors, total
        }
    }
    validate = () => {
        let required = [
            "payment_date",
            "payment_total_amount",
            "payment_bank",
            "payment_mode",
            "payment_ref",
        ]
        let validPayments = this.validatePayments()
        let noError = validPayments.noError
        let errors = [].concat(this.state.errors)
        errors.payments = validPayments.errors
        

        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        if (parseFloat(this.state.payment_total_amount) !== parseFloat(validPayments.total) ){
            noError = false
            errors.payment_total_amount = "Le total ne correspond pas"
        }
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_total_amount =  parseFloat(this.state.payment_total_amount)
            data.payment_mode =  this.state.payment_mode
            data.payment_bank =  this.state.payment_bank
            data.payment_ref =  this.state.payment_ref
            data.payment_remarks =  this.state.payment_remarks
            // data.payment_spending_id =  this.state.payment_spending_id
            data.payments_spendings =  this.state.payments
            
            console.log('====================================');
            console.log("submit payment", {data});
            console.log('====================================');
            await this.props.newPayment(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    validateUpdate = () => {
        let required = [
            "payment_date",
            "payment_bank",
            "payment_mode",
            "payment_ref",
        ]

        let noError = true
        let errors = [].concat(this.state.errors)        

        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    handleUpdate = async () => {

        if( this.validateUpdate() ){
            let data = this.props.payment
            data.payment_date = this.state.payment_date
            data.payment_update_date = new Date()
            data.payment_mode =  this.state.payment_mode
            data.payment_bank =  this.state.payment_bank
            data.payment_ref =  this.state.payment_ref
            data.payment_remarks =  this.state.payment_remarks
            
            console.log('====================================');
            console.log("submit update payment", {data});
            console.log('====================================');
            await this.props.updatePayment(data)

            // // if NoErrors ...
            if(this.props.STATE.payments.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.payments.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        console.log("New payment PROPS", this.props);
        
        const { BANKS, update } = this.props;

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
       
        return (                
            <Dialog
                close={this.props.handleClose}
                fullScreen={!update}
                maxWidth={update && "md"}
                appBar
                title={update ? "Modifier" : "Nouveau Paiement"}
                submitAction={this.props.update ? this.handleUpdate : this.handleSubmit}
                disabledSubmit={this.props.STATE.payments.fetching}
            >
                <Grid container spacing={3}>
                    <Grid container item xs={12} sm={6}>
                        <Grid item xs={12}>
                            <DatePicker  
                                id="payment_date"
                                label="Date de Paiement"
                                name="payment_date"
                                value={this.state.payment_date}
                                error={this.state.errors.payment_date}
                                handleChange={this.handleChangeDate} 
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <InputText
                                required
                                disabled={update}
                                onChange={!update && this.handleChange}
                                name="payment_total_amount" 
                                id="payment_total_amount" 
                                value={this.state.payment_total_amount} 
                                label="Montant Payé" 
                                error={this.state.errors.payment_total_amount}
                            />
                        </Grid>          
                        {this.state.payment_mode !== "COLLAB" && // for update
                        <Fragment>
                            <Grid item xs={12}>
                                <InputSelectNative
                                    value={this.state.payment_mode}
                                    onChange={this.handleChange}
                                    labelWidth={170} 
                                    name="payment_mode" 
                                    id="payment_mode"
                                    label="Mode de Paiement"
                                    required 
                                    error={this.state.errors.payment_mode}
                                    options={[
                                        <option value="ESPECES">ESPECES</option>,
                                        <option value="CHEQUE">CHEQUE</option>,
                                        <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                        <option value="VIREMENT">VIREMENT</option>,
                                        <option value="GAB">GAB</option>,
                                        <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputText
                                    onChange={this.handleChange}
                                    required
                                    id="payment_ref"
                                    error={this.state.errors.payment_ref}
                                    value={this.state.payment_ref}
                                    name="payment_ref"
                                    label="Réference Paiement"
                                />
                            </Grid>
                        </Fragment>
                        }
                            
                    </Grid>
                    <Grid container item xs={12} sm={6}>
                        {this.state.payment_mode !== "COLLAB" &&
                            <Grid item xs={12} >
                                <InputSelectNative
                                    label="Banque"
                                    onChange={this.handleChange}
                                    error={this.state.errors.payment_bank}
                                    value={this.state.payment_bank}
                                    name="payment_bank" 
                                    labelWidth={60} 
                                    id="payment_bank" 
                                    options={ Object.values(BANKS).map( bank  => (
                                        <option value={bank.bank_id} key={bank.bank_id}>
                                            {bank.bank_name}
                                        </option>
                                    )) }
                                />      
                            </Grid>                                    
                        }
                        <Grid item xs={12} >
                            <TextArea
                                onChange={this.handleChange}
                                rows={this.state.payment_mode !== "COLLAB" ? 10 : 7}
                                name="payment_remarks" 
                                id="payment_remarks" 
                                value={this.state.payment_remarks} 
                                label="Remarques" 
                            />
                        </Grid>
                    </Grid>                                     
                </Grid>
                {!update &&        
                    <Grid>
                        {this.createAddForm()}
                        <Button variant="contained" onClick={this.handleAddForm} color="primary">
                            Ajouter une autre dépense
                        </Button>
                    
                    </Grid>
                }                                  
            </Dialog>
        )
    }
}

export default PaymentForm;